import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a20afc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loadingForeground" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from "vue";

export interface Props {
  background?: string;
  loader_main?: string;
  loader_secondary?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheLoading',
  props: {
    background: { default: "#000000" },
    loader_main: { default: "#ffffff" },
    loader_secondary: { default: "#303030" }
  },
  setup(__props: any) {

const props = __props;

const styles = computed(() => {
  return `--background: ${props.background}; --loader-main: ${props.loader_main}; --loader-secondary: ${props.loader_secondary};`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "loadingBackground",
    style: _normalizeStyle(styles.value)
  }, _hoisted_2, 4))
}
}

})